(() => {
  const run = () => {
    const m = document.getElementById('ats-NewsletterPopup');
    if (!m) return;

    const ls = localStorage,
      DIS = 'ats_nl_dismissed_at',
      SUB = 'ats_nl_subscribed',
      CAP = 7;
    if (ls.getItem(SUB) === '1') return;
    const d = ls.getItem(DIS);
    if (d && (Date.now() - +d) / 864e5 < CAP) return;

    const show = () => {
      m.classList.remove('tw-hidden');
      document.documentElement.style.overflow = 'hidden';
      m.querySelector('input[type="email"]')?.focus({ preventScroll: true });
    };
    const hide = () => {
      m.classList.add('tw-hidden');
      document.documentElement.style.overflow = '';
    };

    setTimeout(show, (+m.dataset.delay || 12) * 1000);

    m.querySelectorAll('[data-nl-close]').forEach((b) =>
      b.addEventListener('click', () => {
        ls.setItem(DIS, Date.now());
        hide();
      })
    );

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !m.classList.contains('tw-hidden')) {
        ls.setItem(DIS, Date.now());
        hide();
      }
    });

   const form = m.querySelector('form[data-nl-form]') || m.querySelector('[data-nl-form]');

form?.addEventListener('submit', (e) => {
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation(); // <-- strongest stop

  const thanks = m.querySelector('[data-nl-thanks]');
  const content = m.querySelector('[data-nl-content]');

  content?.classList.add('tw-hidden');
  thanks?.classList.remove('tw-hidden');

  ls.setItem(SUB, '1');
}, true); // <-- capture phase
  // Copy coupon button
m.querySelector('[data-nl-copy]')?.addEventListener('click', () => {
  const code = m.querySelector('[data-nl-coupon]')?.textContent?.trim();
  if (!code) return;
  navigator.clipboard?.writeText(code);
});


  };


  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
})();
